type IAffiliateIdsResponse = string[]

export const resolveAffiliateIds = (story: any): IAffiliateIdsResponse =>
  story.data.stories[0].content?.affiliateId
